import { render } from "./QueueNavigationCard.vue?vue&type=template&id=4c0d3cd7&scoped=true&ts=true"
import script from "./QueueNavigationCard.vue?vue&type=script&lang=ts"
export * from "./QueueNavigationCard.vue?vue&type=script&lang=ts"

import "./QueueNavigationCard.vue?vue&type=style&index=0&id=4c0d3cd7&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0d3cd7"]])

export default __exports__